import { Box, Container } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import PageAppBar from "./PageAppBar";
import PageTabs from "./PageTabs";
import Profile from "./Profile";
import Billing from "./Billing";

export default function Account() {
  const searchParams = useSearchParams()[0];
  const view = searchParams.get("view") || "profile";
  return (
    <Box>
      <PageAppBar />
      <PageTabs />
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        {view === "profile" ? <Profile /> : <Billing />}
      </Container>
    </Box>
  );
}
